import React, { useEffect, useState } from "react";
import ComponentWiseScore from "./componentScore";
import PatcipantReport from "./ComplParticReport";
import ReportStaticPart1 from "./ReportStaticPart1";
import ReportStatPart2 from "./ReportStatPart2";
import StatementWiseScore from "../statemetnScore";
import QualitativeFeedback from "./section3";
import TopStrengthandwekanesss from "./section4";
import StrengthsAndWeaknesses from "./HiddenStrngth";
import OverAllSummary from "./OoverAllSummary";
import CaveatAndNote from "./CravetAndNote";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Logo from "../../assets/images/logo.png";
import { useAuth } from "../../context/AuthContext";
import { Link, useParams } from "react-router-dom";
import FancyLoader from "../../hooks/FancyLoder";
import PatcipantRep2 from "./ComplParticRep2";
import {
  fetchUserAllAssessments,
  getAllParticipantsOfAssessment,
} from "../../services/authService";
import { decodeId } from "../../utills/idUtils";
const ReportPage = () => {
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assessmentStatus, setAssessmentStatus] = useState(""); // Store the assessment status

  console.log({assessmentStatus},"assessmenassessmentStatustStatus")

  const [pdfState, setPdfState] = useState();
  const [loadingAssessment, setLoadingAssessment] = useState(true);
  const [error, setError] = useState(null);
  const { state } = useAuth();
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const { user } = state;
  const API_URL = process.env.REACT_APP_API_URL;
  const PDF_URL = process.env.REACT_APP_PDF_URL;

  const userId = user?.user_id;

  useEffect(() => {
    fetchAssessmentDetails();
  }, [userId]);

  // Fetch assessment details
  const fetchAssessmentDetails = async () => {
    try {
      const assessmentResponse = await fetchUserAllAssessments(userId);
      ////console.log('Assessment Details:', assessmentResponse.initiatorAssessments);
      const selectedAssessment = assessmentResponse.initiatorAssessments.find(
        (assessment) => assessment.assessment_id === parseInt(id)
      );
      if (selectedAssessment) {
        //console.log("selectedAssessment", selectedAssessment)
        setAssessmentStatus(selectedAssessment);
      } else {
        setError("Assessment not found");
      }
    } catch (err) {
      setError(`Failed to fetch assessment: ${err.message}`);
    } finally {
      setLoadingAssessment(false);
    }
  };

  const handleDownload = async () => {
    setIsGeneratingPdf(true);
    toggleDownloadButtons(true);

    setTimeout(async () => {
      const htmlContent = document.getElementById("contentToConvert").innerHTML;
      try {
        const htmlC = `
    <html>
      <head>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" crossorigin="anonymous" referrerpolicy="no-referrer" />
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Lora&family=Poppins&display=swap" rel="stylesheet">
        <style>
          * {
            box-sizing: border-box;
          }
          html, body {
            margin: 0;
            padding: 0;
            font-family: 'Poppins', sans-serif;
          }
          #contentToConvert {
            width: 100%;
            height: 100vh;
            overflow: visible !important;
            font-size:16px
          }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
    </html>
  `;

        let header = "";
        if (assessmentStatus.assessment_type === "360") {
          header = "Executive Presence 360° Assessment Report";
        } else {
          header = "Executive Presence Self-Assessment Report";
        }

        const formData = new FormData();
        formData.append("htmlContent", htmlC); // HTML string
        formData.append("header", header); // Add the type directly

        const response = await fetch(`${API_URL}/generate-pdf`, {
          method: "POST",
          body: formData, // Do NOT wrap inside another object
        });

        const data = await response.json();
        console.log('data>>>',data)
        if (data.success) {
          const fileUrl = `${PDF_URL}/pdfs/${data.filename}`;
          const fileName = `Executive Presence Report for ${user.first_name}.pdf`;
          fetch(fileUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error("File fetch failed");
              }
              return response.blob();
            })
            .then((blob) => {
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = blobUrl;
              a.download = fileName || "download.pdf"; // fallback
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(blobUrl);
            })
            .catch((err) => {
              console.error("Download error:", err);
            });
          setLoading(false);
          setIsGeneratingPdf(false);
          toggleDownloadButtons(false);
        } else {
          alert("Failed to generate PDF");

          setIsGeneratingPdf(false);
          toggleDownloadButtons(false);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Failed to generate PDF: " + error.message);
      }
    }, 2000);
  };

  const addPageDecorations = (
    pdf,
    {
      footerText,
      logoURL,
      pageNumber,
      pageWidth,
      pageHeight,
      footerFontSize,
      logoWidth,
      logoHeight,
      isFirstPage,
    }
  ) => {
    if (!isFirstPage) {
      pdf.addImage(
        logoURL,
        "PNG",
        pageWidth - logoWidth - 10,
        10,
        logoWidth,
        logoHeight
      );
    }

    pdf.setFontSize(footerFontSize);
    pdf.setTextColor(100, 100, 100);

    const textWidth = pdf.getTextWidth(footerText);
    pdf.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);

    pdf.text(`Page ${pageNumber}`, pageWidth - 30, pageHeight - 5, {
      align: "right",
    });
  };

  const toggleDownloadButtons = (isDownloading) => {
    document
      .querySelector(".downloadingBtn")
      ?.classList.toggle("hidden", !isDownloading);
    document
      .querySelector(".downloadButton")
      ?.classList.toggle("hidden", isDownloading);
  };

  if (loading)
    return (
      <div>
        <FancyLoader />
      </div>
    );

  return (
    <div>
      <div
        data-aos="fade-up"
        id="contentToConvert"
        className={`pdf-reset bg-gray-100`}
      >
        {isGeneratingPdf ? (
          <PatcipantRep2 isGeneratingPdf={isGeneratingPdf} assessment_type={assessmentStatus.assessment_type} />
        ) : (
          <PatcipantReport isGeneratingPdf={isGeneratingPdf} assessment_type={assessmentStatus.assessment_type} />
        )}

        <ReportStaticPart1 isGeneratingPdf={isGeneratingPdf} />
        <ReportStatPart2 isGeneratingPdf={isGeneratingPdf} />
        <ComponentWiseScore isGeneratingPdf={isGeneratingPdf} />
        <StatementWiseScore
          addPage={pdfState}
          isGeneratingPdf={isGeneratingPdf}
          assessment_type={assessmentStatus.assessment_type}
        />
        <QualitativeFeedback />
        <TopStrengthandwekanesss isGeneratingPdf={isGeneratingPdf} assessment_type={assessmentStatus.assessment_type} />
        <StrengthsAndWeaknesses isGeneratingPdf={isGeneratingPdf} />
        <OverAllSummary isGeneratingPdf={isGeneratingPdf} assessment_type={assessmentStatus.assessment_type} />
        <CaveatAndNote
          // onDownalod={handleDownload}
          isGeneratingPdf={isGeneratingPdf}
          assessment_type={assessmentStatus.assessment_type}
        />
      </div>
      <div className="text-center mb-4 mt-8">
        <span
          id="downloadingBtn"
          className="downloadingBtn hidden text-center text-white bg-green-500 py-2 px-4 ml-2 rounded-lg"
        >
          Report is generating. Please wait.
        </span>
        <button
          id="downloadButton"
          onClick={handleDownload}
          className="bg-green-500 downloadButton  text-white py-2 px-4 rounded-lg hide-for-pdf "
        >
          Download Report As PDF
        </button>

        <br />
        <p id="apttext" className="mt-4 hide-for-pdf">
          Make an appointment with Coach Kshitij to explore one-on-one Executive
          Coaching.
        </p>
        <a
          rel="noreferrer"
          href="https://calendly.com/epcoachkshitij/"
          target="_blank"
          className="inline-block text-blue-600 font-bold py-2 px-4 rounded-lg  transition duration-300"
        >
          <button
            id="appointmentButton"
            className="bg-blue-500 hideIt text-white py-2 px-4 rounded-lg mt-4 hide-for-pdf"
          >
            Make an appointment
          </button>
        </a>

        <div class="flex justify-center space-x-4 mt-8">
          <Link id="hme" to="/">
            <button className="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-500 transition">
              Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReportPage;
